import React, { Component } from "react";
import Home from "./Home";
import { BrowserRouter as Router, Route } from "react-router-dom";

class App extends Component {

    render() {
        return (
            <Router basename="Sv6fHSty">
                    <Route path="/" exact component={Home} />
            </Router>
        );
    }
}


export default App;